import { Form } from 'react-bootstrap';
import { WEEKDAYS } from './unitSectionConstants';

export const ScheduledWaterFlushSection = ({
  scheduledWF,
  onScheduledWFChange
}) => {
  if (!scheduledWF) return null;

  return (
    <Form.Group className="text-start mt-4 col-12" controlId="scheduledWF">
      <Form.Label><strong>SCHEDULED WATER FLUSH</strong></Form.Label>

      {/* Toggle Enable / Disable */}
      <div className="d-flex align-items-center gap-3 my-2">
        <Form.Check
          type="switch"
          id="scheduledWF-toggle"
          checked={scheduledWF.enabled}
          onChange={() => onScheduledWFChange("enabled", !scheduledWF.enabled)}
        />
        <span>{scheduledWF.enabled ? "Enabled" : "Disabled"}</span>
      </div>

      {/* Config options if enabled */}
      {scheduledWF.enabled && (
        <>
          {/* Iterations */}
          <div className="my-3">
            <Form.Label><strong>Iterations</strong></Form.Label>
            <Form.Control
              type="number"
              value={scheduledWF.iterations}
              onChange={(e) => {
                const newValue = parseInt(e.target.value, 10);
                if (!isNaN(newValue) && newValue > 0) {
                  onScheduledWFChange("iterations", newValue);
                }
              }}
              min="1"
              placeholder="Enter iterations"
            />
          </div>

          {/* Time */}
          <div className="my-3">
            <Form.Label><strong>Time</strong></Form.Label>
            <Form.Control
              type="time"
              value={scheduledWF.time}
              onChange={(e) => onScheduledWFChange("time", e.target.value)}
            />
          </div>

          {/* Weekdays */}
          <div className="my-3">
            <Form.Label><strong>Weekdays</strong></Form.Label>
            <div className="d-flex flex-wrap gap-3">
              {WEEKDAYS.map((day) => (
                <Form.Check
                  key={day}
                  type="checkbox"
                  label={day}
                  checked={scheduledWF.weekDays?.[day] || false}
                  onChange={(e) => 
                    onScheduledWFChange(`weekDays.${day}`, e.target.checked)
                  }
                />
              ))}
            </div>
          </div>
        </>
      )}
    </Form.Group>
  );
};